var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.82509 9.00005L8.72509 13.9C8.92509 14.1 9.02109 14.3334 9.01309 14.6C9.00509 14.8667 8.90075 15.1 8.70009 15.3C8.50009 15.4834 8.26675 15.5794 8.00009 15.588C7.73342 15.5967 7.50009 15.5007 7.30009 15.3L0.700087 8.70005C0.600087 8.60005 0.529087 8.49172 0.487087 8.37505C0.445087 8.25838 0.424754 8.13338 0.426087 8.00005C0.42742 7.86672 0.44842 7.74172 0.489087 7.62505C0.529753 7.50838 0.60042 7.40005 0.701087 7.30005L7.30109 0.700048C7.48442 0.516715 7.71375 0.425049 7.98909 0.425049C8.26442 0.425049 8.50175 0.516715 8.70109 0.700048C8.90109 0.900048 9.00109 1.13772 9.00109 1.41305C9.00109 1.68838 8.90109 1.92572 8.70109 2.12505L3.82509 7.00005H15.0001C15.2834 7.00005 15.5211 7.09605 15.7131 7.28805C15.9051 7.48005 16.0008 7.71738 16.0001 8.00005C15.9994 8.28272 15.9034 8.52038 15.7121 8.71305C15.5208 8.90572 15.2834 9.00138 15.0001 9.00005H3.82509Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackarrow);
export default __webpack_public_path__ + "static/media/backarrow.5fecf790d0dfae57b731a8cd278207b4.svg";
export { ForwardRef as ReactComponent };